import { Component } from '@angular/core';

@Component({
    selector: 'app-confirmation-bdp',
    templateUrl: './confirmation-bdp.component.html',
    styleUrls: ['./confirmation-bdp.component.scss'],
    standalone: false,
})
export class ConfirmationBDPComponent {}
